"use client";
import React from "react";
import {
  Box,
  Separator,
  Table,
  Text,
  VStack,
  Stack,
  HStack,
  SimpleGrid,
  Center,
} from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { MICROSOFT_MANAGED_BUNDLES } from "./constants";
import { FaMicrosoft } from "@onemind-services-llc/react-icons-ng/fa";

export const DesktopView = () => {
  return (
    <Table.Root striped border="2px solid rgb(237,242,247)" width="100%">
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader textAlign="center">Minimum User Tier</Table.ColumnHeader>
          <Table.ColumnHeader textAlign="center">
            Per User Monthly Price
          </Table.ColumnHeader>
          <Table.ColumnHeader textAlign="center">Microsoft License</Table.ColumnHeader>
          <Table.ColumnHeader textAlign="center">Support Hours/Month</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {MICROSOFT_MANAGED_BUNDLES.map((bundle, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign="center">{bundle.minUserTier}</Table.Cell>
            <Table.Cell textAlign="center">
              <Text fontWeight="700" color="primary.200" fontSize="18px">
                {bundle.pricePerUser}
              </Text>
            </Table.Cell>
            <Table.Cell textAlign="center">{bundle.license}</Table.Cell>
            <Table.Cell textAlign="center">{bundle.supportHours}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
      {MICROSOFT_MANAGED_BUNDLES.map((bundle, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          gap={4}
          w="100%"
          p={4}
          bg="white"
        >
          <HStack gap={3} align="center" w="full">
            <Box
              h="2.5rem"
              w="2.5rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="md"
              bg="gray.50"
            >
              <FaMicrosoft color="#F25022" size="1.5rem" />
            </Box>
            <Text fontWeight="bold" fontSize="lg">
              {bundle.license}
            </Text>
          </HStack>

          <Separator borderColor="gray.200" />

          <Stack gap={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Minimum User Tier
            </Text>
            <Text fontWeight="medium">{bundle.minUserTier}</Text>
          </Stack>

          <Stack gap={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Per User Monthly Price
            </Text>
            <Text fontWeight="bold" fontSize="lg" color="primary.200">
              {bundle.pricePerUser}
            </Text>
          </Stack>

          <Stack gap={2} w="full">
            <Text fontSize="sm" color="gray.600">
              Support Hours/Month
            </Text>
            <Text fontWeight="medium">{bundle.supportHours}</Text>
          </Stack>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const MicrosoftServicesTable = ({ showHeading = true }: { showHeading?: boolean }) => {
  const HeadingVariant = useHeadingVariant();

  return (
    <Box id="microsoft-services-bundles">
      {showHeading && (
        <Heading variant={HeadingVariant} textAlign="center" mb={8}>
          Managed Services Microsoft Bundles
        </Heading>
      )}
      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>

      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
    </Box>
  );
};

export default MicrosoftServicesTable;
